import EventHandler from "./EventHandler";
import {EventName, Events} from "./Event";


export class EventDispatcher {
    private handlers: Array<Array<EventHandler>> = [];

    public addEventHandler = (handler: EventHandler): string => {
        const identifier = String(Math.random());

        for (const i in handler.handledEvents) {
            if (!this.handlers[handler.handledEvents[i] as unknown as number]) {
                this.handlers[handler.handledEvents[i] as unknown as number] = [];
            }
            this.handlers[handler.handledEvents[i] as unknown as number][identifier as unknown as number] = handler;
        }

        return identifier;
    }

    public removeEventListener = (identifierToDelete: string): void => {
        for (const eventName in this.handlers) {
            for (const identifier in this.handlers[eventName]) {
                if (identifier === identifierToDelete) {
                    delete this.handlers[eventName][identifier];
                }
            }
        }
    }

    public dispatch = (events: Partial<Events>): void => {
        console.debug('EVENTS', events);

        Object.keys(events).forEach(eventName => {
            const idx = eventName as unknown as number;
            if (!this.handlers[idx]) {
                console.warn('NO EVENT LISTENER FOR EVENT: ' + eventName);
                return;
            }

            for (const i in this.handlers[idx]) {
                this.handlers[idx][i].handle({[eventName]: events[idx as unknown as EventName]} as Events);
            }
        })
    }
}
